import { html, LitElement } from "lit";
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from "lit/directives/style-map.js";
import { constructGridHourHtml, constructGridTemplateRows } from "./utils";

import style from './usos-timetable.scss';

/**
 * Timetable component
 * @slot - should contains HTML structure like
 * <div>
 *   <div><h[2-6]>Day</h[2-6]></div>
 *   <timetable-day>(...)</timetable-day>
 * </div>
 * for every day
 *
 * @cssproperty [--timetable-row-height] - height of quaters' spacing; default: 1.25rem or 0.125rem for [mini]
 * @cssproperty [--timetable-border-color=var(--border)] - timetable lines' color
 */

@customElement('usos-timetable')
export class Timetable extends LitElement {
    static override styles = style;

    /** Show mini timetable, to be used e.g. as a thumbnail */
    @property({ type: Boolean, reflect: true }) mini = false;

    /** Hour to draw timetable from */
    @property({ attribute: 'start', type: Number }) startTime = 8;
    /** Last full hour to be drawn on timetable  */
    @property({ attribute: 'end', type: Number }) endTime = 16;

    override render() {
        const rowsStyles = constructGridTemplateRows(this.startTime, this.endTime);
        return html`
            <div>
                <div class="pseudo-header" aria-hidden="true">&nbsp;</div>
                <div id="hours" aria-hidden="true" style=${styleMap(rowsStyles)}>
                    ${constructGridHourHtml(this.startTime, this.endTime, this.mini)}
                </div>
            </div>
            <div id='timetable' tabindex=0>
                <slot></slot>
            </div>
        `;
    }

    override updated() {
        this.querySelectorAll('timetable-day').forEach(el => { el.mini = this.mini; el.startTime = this.startTime; el.endTime = this.endTime; });
        this.querySelectorAll('timetable-entry').forEach(el => el.mini = this.mini);
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'usos-timetable': Timetable,
    }
}
